import type { ShopDto, UpdateShopExchangeDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";
import { useApiMutation } from "./use-api-mutation";

export default function useUpdateShopExchange(shop: ShopDto) {
  const invalidateShop = useInvalidateShop(shop.id);

  return useApiMutation("patch", "/shops/{shopId}/exchanges", {
    invalidate: invalidateShop,
    mapVariables: (data: UpdateShopExchangeDto) => ({
      params: { path: { shopId: shop.id } },
      body: data,
    }),
  });
}
